import React, { Component } from "react";
import colors from "../colors";
import CustomFadeIn from "./CustomFadeIn";
import LeftNav from "./LeftNav";
import Navbar from "./Navbar";
import { useSelector } from "react-redux";
import PageTitle from "./PageTitle";
import AdminNavbar from "../components/AdminNavbar";
import LoadingComponent from "./LoadingComponent";

const AdminPageTemplate = ({ fadeIn = true, children, maxWidth, title, right, scroll, loading }) => {
  const loggedInUser = useSelector((state) => state.loggedInUser);

  const styles = {
    outsideWrapper: {
      height: "100vh",
      // position: "relative",
      // minWidth: 600,
      // display: "flex",
      // flexDirection: "row",
      // paddingTop: 60
      // height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      minHeight: "min-content",
      overflow: "hidden",
    },
    insideWrapper: {
      // height: "100%",
      // overflowY: "auto",
      // width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      flex: 1,
      marginTop: 60,
      minHeight: "min-content",
      overflow: "hidden",

      // paddingTop: 60,
      // paddingLeft: loggedInUser.id ? 250 : 0
    },
    body: {
      padding: 20,
      paddingTop: 10,
      // minHeight: "100%",
      // position: "relative",
      // width: "100%",
      flex: 1,
      display: "flex",
      flexDirection: "column",
      minHeight: "min-content",
      overflow: scroll ? "auto" : "hidden",
      position: "relative",
      // backgroundColor: 'red',
      // display: 'flex',
    },
    footer: {
      height: 300,
      backgroundColor: colors.lightBG,
      width: "100%",
      padding: 20,
    },
    top: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      paddingTop: 5,
    },
  };

  const body = fadeIn ? (
    loading ? (
      <LoadingComponent />
    ) : (
      <CustomFadeIn maxWidth={maxWidth || 1200}>
        <div style={styles.body} id="pageBody">
          {children}
        </div>
      </CustomFadeIn>
    )
  ) : (
    <div style={styles.body} id="pageBody">
      {loading ? <LoadingComponent absolute={true} /> : null}
      {loading ? null : children}
    </div>
  );

  return (
    <div style={styles.outsideWrapper}>
      <AdminNavbar />
      {/* {loggedInUser.id ? <LeftNav /> : null} */}
      <div style={styles.insideWrapper}>
        <div style={styles.top}>
          {title ? <PageTitle title={title} /> : null}
          <div style={styles.topRight}>{right ? right : null}</div>
        </div>
        {body}
        {/* <div style={styles.footer}>footer</div> */}
      </div>
    </div>
  );
};

export default AdminPageTemplate;
